export default __webpack_public_path__ + "static/media/Della Toffola.8c40dfe8.png";